import React from "react";
// import "./AddCustomerDetailsMobileView.css";
// import { useRouter } from "next/router";
import CallIcon from "@mui/icons-material/Call";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhotoIcon from "@mui/icons-material/Photo";
import "../../components/AddPetDetails/DesktopView/AddPetDetailsDesktopView.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import { Pencil } from "lucide-react";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import banner from "../../images/ScreenshotEn.png";

function BookingForm() {
  const [originCityResponse, setOriginCityResponse] = useState([]);
  const [originStateResponse, setOriginStateResponse] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [orderSummary, setOrderSummary] = useState([]);
  // const [orderRelocation, setOrderRelocation] = useState([]);
  const location = useLocation();
  const [VaccinationBook_Front, setVaccinationBookFront] = useState(null);
  const [vaccinationBookBack, setVaccinationBookBack] = useState(null);
  const [petPhotosSitting, setPetPhotosSitting] = useState(null);
  const [petPhotosStanding, setPetPhotosStanding] = useState(null);
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [isEditMode, setIsEditMode] = useState(true);
  // const router = useRouter(); // or useNavigate() for react-router-dom
  // const [relocationID, setRelocationID] = useState("");

  const contentRef = useRef();

  const handleDownloadPDF = () => {
    const input = document.getElementById("pdf-content");

    html2canvas(input, {
      scale: 3, // Increase the scale for higher resolution
      useCORS: true, // Ensure cross-origin images are rendered
      backgroundColor: "#ffffff", // Explicitly set background to white to avoid transparency issues
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0); // Use 1.0 for best quality
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = 210; // 210 mm
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("bookingForm.pdf");
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    First_Name: "",
    Last_Name: "",
    Mobile_No: "",
    alternate_number: "",
    Email: "",
    origin_country: "",
    origin_state: "",
    origin_city: "",
    origin_address: "",
    Origin_Pin: "",
    sender_contact_no: "",
    sender_alternate_no: "",
    sender_alternate_email: "",
    destination_country: "",
    destination_state: "",
    destination_city: "",
    destination_contact_person: "",
    receiver_contact_no: "",
    receiver_alternate_no: "",
    receiver_alternate_email: "",
    destination_address: "",
    Destination_Pin: "",
    Number_Of_Pets: "",
    PetType: "",
    pet_Name: "",
    pet_breed: "",
    petbreedtype: "",
    pet_gender: "",
    Pet_Age: "",
    pet_behaviour: "",
    pet_color: "",
    Pet_Length: "",
    Pet_Height: "",
    Pet_Width: "",
    container_length: "",
    VaccinationBook_Front: "",
    VaccinationBook_Back: "",
    Pet_Photo_Sitting: "",
    Pet_Photo_Standing: "",
  });

  const handleSaveAndNext = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        `${baseAPI}customer/UpdateRelocationAllOrderSummary`,
        firstItem,
      );

      // If post is successful, switch to read/view mode
      setIsEditMode(true);
      getCustomerDetail();
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  useEffect(() => {
    getCustomerDetail();
  }, []);

  async function getCustomerDetail() {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    console.log("Decrypted Relocation ID:", Relocation_ID);

    setFirstItem((prevItem) => ({
      ...prevItem,
      relocation_id: Relocation_ID,
    }));

    try {
      const response = await axios.get(
        `${baseAPI}customer/GetCustomerOrderSummaryNew?relocation_id=${Relocation_ID}`,
      );
      const data = response.data?.data?.[0];
      if (data) {
        console.log("hello");
        setOrderSummary(data);
        setFirstItem(data);

        getState();
        getCity(data.Origin_State);

        setVaccinationBookFront(`${baseImageURL}${data.VaccinationBook_Front}`);
        setVaccinationBookBack(`${baseImageURL}${data.VaccinationBook_Back}`);
        setPetPhotosSitting(`${baseImageURL}${data.Pet_Photo_Sitting}`);
        setPetPhotosStanding(`${baseImageURL}${data.Pet_Photo_Standing}`);

        console.log("Order Summary:", data);
      } else {
        console.error("No data found for the given Relocation_ID");
      }
    } catch (error) {
      console.error("Error fetching user detail:", error);
    }

    // This should always run even if token is not available
    getState();
  }

  //  const handleBack = () => {
  //   router.push(`/ClientDocuments?id=${relocationID}`);
  // };

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd",
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  function getCity(state_id) {
    if (state_id != null && state_id !== "0") {
      axios
        .get(`${baseAPI}admin/GETCity?cityID=0&stateID=` + state_id)
        .then((response) => {
          setOriginCityResponse(response.data.data);
        });
    }
  }

  const handleSelectChangeOriginState = (event) => {
    // Handle the select input change and update the selected value
    firstItem.origin_state = event.target.value;
    getCity(event.target.value);
  };

  function getState() {
    axios
      .get(`${baseAPI}admin/GETState?stateID=0&countryID=0`)
      .then((response) => {
        setOriginStateResponse(response.data.data);
      });
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    // Update the state for the given field
    setFirstItem((prevItem) => {
      const updatedItem = {
        ...prevItem,
        [name]: value,
      };
      return updatedItem;
    });
  };

  //--------------------Upload Img
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    console.log(`Uploading file: ${file.name} for field: ${fieldName}`);

    uploadFile(file, fieldName);
  };

  const uploadFile = async (file, fieldName) => {
    const reader = new FileReader();

    reader.onload = async () => {
      const byteImg = reader.result;
      const mediaData = {
        type: "image",
        url: byteImg,
      };

      try {
        const response = await axios.post(
          `${baseAPI}customer/UploadImage`,
          mediaData,
        );

        if (response && response.data) {
          setFirstItem((prevFirstItem) => ({
            ...prevFirstItem,
            [fieldName]: response.data.data,
          }));
        }
      } catch (error) {
        console.error("Error posting data:", error);
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <div style={{ backgroundColor: "rgb(242, 244, 246)" }}>
      {isEditMode ? (
        <>
          <div className="ms pt-4 pb-4 lg:py-4 lg:px-[15.5rem] booking_form-mobile-view">
            <div
              className="pt-3 pr-[23px] pb-3 pl-[20px] lg:py-3 lg:px-3"
              style={{
                borderRadius: "7px",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                backgroundColor: "white",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="hidden sm:inline-block border-b-2 border-blue-500 pb-1 font-semibold text-xl m-0">
                  BOOKING FORM
                </h2>

                <div className="flex gap-2 ms-auto">
                  {/* Edit Button */}
                  <button
                    onClick={() => setIsEditMode(!isEditMode)}
                    className=" arrow-download_page font-bold px-2 sm:px-4 py-2 border border-blue-500 sm:border-gray-300 w-auto sm:w-[7rem] bg-white text-[#6A6A6A] rounded-[9px] flex items-center justify-center sm:justify-start gap-2"
                  >
                    <Pencil cla size={18} className="text-[#6A6A6A]" />
                    <span className="hidden sm:inline">Edit</span>
                  </button>

                  {/* Download Button */}
                  <button
                    onClick={handleDownloadPDF}
                    type="button"
                    className="arrow-download_page font-bold px-4 py-2 border border-blue-500 w-[2.5rem] sm:w-[12rem] bg-white text-[#6A6A6A] rounded-[9px] flex items-center justify-center sm:justify-start gap-2"
                  >
                    <span className="text-[20px]">&#x2193;</span>
                    <span className="hidden sm:inline">Download Page</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ marginBottom: "30px" }}
            className="lg:py-4 lg:px-[15.5rem]"
          >
            <div
              className="p-3 lg:py-[1rem] lg:px-[2rem] order-by-mukul_change"
              style={{
                borderRadius: "7px",
                // boxShadow:
                //   "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                // backgroundColor: "white",
              }}
            >
              <h1
                className="mt-3 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none for-desktop-m"
              >
                Booking Person
              </h1>
              {/* Mobile view Booking Person */}

              <h1
                className="mt-3 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold  rounded-br-none rounded-bl-none for-mobile-none"
              >
                Booking Person
              </h1>

              <div className="lead-info-box hide-mobile-view">
                <div className="lead-row">
                  <span className="lead-label">Lead Id</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Relocation_ID || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Full Name</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.First_Name || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Contact No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Mobile_No || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Alternate No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.alternate_number || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Email Id</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Email || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Address</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_address || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pin Code</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Origin_Pin || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">State</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_state1 || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">City</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_city1 || "NA"}
                  </span>
                </div>
              </div>

              {/* Desktop view Booking Person*/}
              <div className="form-row row align-items-start g-3 mt-3 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Lead ID
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Relocation_ID || "NA"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Full Name
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.First_Name || "NA"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start position-relative">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Contact Number
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 34px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                    className="form-control m-0"
                  >
                    <CallIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                      }}
                    />
                    {orderSummary.Mobile_No || "NA"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start position-relative">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Alternate Number
                  </label>

                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // left padding for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <SmartphoneIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "18px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.alternate_number || "NA"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Email ID
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // left padding for icon
                        fontWeight: "bold",
                        borderRadius: "4px",
                        //  backgroundColor: "#f9f9f9",
                        position: "relative",
                      }}
                    >
                      <MailOutlineIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "18px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.Email || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",
                        //  backgroundColor: "#f9f9f9",
                        position: "relative",
                      }}
                    >
                      <LocationOnIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "18px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.origin_address || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pin Code
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 10px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      {orderSummary.Origin_Pin || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    State
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.origin_state1 || "NA"}
                  </div>
                </div>
              </div>

              <div className="form-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    City
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                      position: "relative",
                    }}
                  >
                    {orderSummary.origin_city1 || "NA"}
                  </div>
                </div>
              </div>
              {/*End  Desktop view Booking Person*/}
              <h1
                className="mt-5 mb-4 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none for-desktop-m"
              >
                Relocation Details
              </h1>

              
              <span className="for-desktop-m" style={{ borderBottom: "7px solid #5B489D" }}>
                Sender's Details{" "}
                {/* <span style={{ color: "#00A3FF" }}>
                  (Same As Customer Details)
                </span> */}
              </span>
              <hr className="m-0 for-desktop-m"></hr>
              {/* Mobile view Booking Person */}

              <h1
                className="mt-5 mb-0 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none for-mobile-none"
              >
                Relocation Details
              </h1>
<div className="lead-info-box hide-mobile-view">
 

              
              <span className="for-mobile-none  text-[#5B489D] font-bold" style={{fontSize: '18px'}}>
                Sender's Details{" "}
                {/* <span style={{ color: "#00A3FF" }}>
                  (Same As Customer Details)
                </span> */}
              </span>
              <hr className="m-0 for-mobile-none"></hr>
              <br></br>
  

               <div className="hide-mobile-view">
                
                <div className="lead-row">
                  <span className="lead-label">Country</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_country1 || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Full Name</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.First_Name || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Contact No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Mobile_No || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Alternate No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.alternate_number || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Email Address</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Email || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Address</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_address || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pin Code</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Origin_Pin || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">State</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_state1 || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">City</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.origin_city1 || "NA"}
                  </span>
                </div>
              </div>

              {/* Mobile view Reciever's Details */}

              <div className="hide-mobile-view">

 <span className="for-mobile-none  text-[#5B489D] font-bold" style={{fontSize: '18px'}}>
                Receiver’s Details{" "}
                {/* <span style={{ color: "#00A3FF" }}>
                  (Same As Customer Details)
                </span> */}
              </span>
              <hr className="m-0 for-mobile-none"></hr>
              <br></br>

                <div className="lead-row">
                  <span className="lead-label">Country</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.destination_country1 || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Full Name</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.destination_contact_person || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Contact No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.receiver_contact_no || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Alternate No.</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.receiver_alternate_no || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Email Address</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.receiver_alternate_email || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Address</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.destination_address || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pin Code</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Destination_Pin || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">State</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.destination_state1 || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">City</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.destination_city1 || "NA"}
                  </span>
                </div>
              </div>
</div>
             

              {/* Desktop view Relocation Details*/}
              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Country
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_country1 || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Full Name
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.First_Name || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Contact Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // for icon spacing
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <CallIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.Mobile_No || "NA"}
                    </div>
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Alternate Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <SmartphoneIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.alternate_number || "NA"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Email Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <MailOutlineIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.Email || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Address
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 34px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        pointerEvents: "none",
                      }}
                    />
                    {orderSummary.origin_address || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pin Code
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Origin_Pin || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    State
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_state1 || "NA"}
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    City
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_city1 || "NA"}
                  </div>
                </div>
              </div>
              {/* Reciever's Details*/}

              <div className="from-row row align-item-start g-3 my-3 for-desktop-m">
                <div className="col-md-12 col-12 text-start">
                  <span style={{ borderBottom: "7px solid #5B489D" }}>
                    Reciever's{" "}
                    <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                      Details
                    </span>
                  </span>
                  <hr className="mt-0"></hr>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Country
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_country1 || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Full Name
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_contact_person || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Contact Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // for icon spacing
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <CallIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.receiver_contact_no || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Alternate Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <SmartphoneIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.receiver_alternate_no || "NA"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Email Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <div
                      className="form-control m-0"
                      style={{
                        border: "0px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        padding: "8px 10px 8px 34px", // space for icon
                        fontWeight: "bold",
                        borderRadius: "4px",

                        position: "relative",
                      }}
                    >
                      <MailOutlineIcon
                        style={{
                          color: "#6a6a6a",
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          fontSize: "16px",
                          pointerEvents: "none",
                        }}
                      />
                      {orderSummary.receiver_alternate_email || "NA"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Address
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 34px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        pointerEvents: "none",
                      }}
                    />
                    {orderSummary.destination_address || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pin Code
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Destination_Pin || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    State
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_state1 || "NA"}
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    City
                  </label>
                  <div
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_city1 || "NA"}
                  </div>
                </div>
              </div>

              <h1
                className="mt-5 mb-4 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none for-mobile-version2"
              >
                Pet Details
              </h1>

              {/* Mobile view Pet Details */}

              <div className="lead-info-box hide-mobile-view mb-10">
                <div className="lead-row">
                  <span className="lead-label">
                    Pet Owner's name on Vaccination Book
                  </span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">{}</span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Type</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.PetType || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">
                    Pet Name (on vaccination book)
                  </span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.pet_Name || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Breed</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.petbreedtype || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label"> Pet Gender</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.pet_gender === "1" ? "Male" : "Female"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Age</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Pet_Age || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Color</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.pet_color || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Behaviour</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.pet_behaviour || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">Pet Length (A)</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Pet_Length || "NA"}
                  </span>
                </div>

                <div className="lead-row">
                  <span className="lead-label">
                    {" "}
                    Pet Height From Ground To Elbow Joint (B)
                  </span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.container_length || "NA"}
                  </span>
                </div>
                <div className="lead-row">
                  <span className="lead-label">Pet Width (C)</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Pet_Width || "NA"}
                  </span>
                </div>
                <div className="lead-row">
                  <span className="lead-label">Pet Height (D)</span>
                  <span className="lead-colon">:</span>
                  <span className="lead-value">
                    {orderSummary.Pet_Height || "NA"}
                  </span>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Owner's name on Vaccination Book
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Type
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.PetType || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Name (on vaccination book)
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                      position: "relative",
                    }}
                  >
                    {orderSummary.pet_Name || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Breed
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.petbreedtype || "NA"}
                  </div>
                </div>
              </div>
              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Gender
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.pet_gender === "1" ? "Male" : "Female"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Age
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Pet_Age || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pet Color
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.pet_color || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    {" "}
                    Pet Behaviour
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.pet_behaviour || "NA"}
                  </div>
                </div>
              </div>
              <div className="from-row row align-item-start g-3 pt-4 hide-desktop-view">
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pet Length (A)
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Pet_Length || "NA "}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pet Height From Ground To Elbow Joint (B)
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.container_length || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pet Width (C)
                  </label>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Pet_Width || "NA"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start position-relative">
                  <label
                    style={{ color: "#6a6a6a" }}
                    className="form-label ml-0"
                  >
                    Pet Height (D)
                  </label>

                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Pet_Height || "NA"}
                  </div>
                  {/* Info icon with tooltip */}
                  {/* <a
                    href="https://www.carrymypet.com/pet-measurement"
                    target="blank"
                    className="position-absolute"
                    style={{
                      top: "73%",
                      right: "-6px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6a6a6a",
                      fontSize: "27px",
                      textDecoration: "none",
                    }}
                  >
                    &#x1F6C8;
                  </a> */}
                </div>
              </div>

              {/* <h1
                className="mt-5 mb-4 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
              >
                Pet Related Pictures
              </h1> */}

              {/* <div className="form-row row text-center px-0 py-3 d-flex justify-content-between pet-detail-main-form ">
                <div
                  className="col-md-6 col-12 px-2 mb-4 d-flex flex-column align-items-center"
                  style={{ position: "relative" }}
                >
                  <h6
                    className="text-start"
                    style={{
                      color: "#6a6a6a",
                      width: "94%",
                      position: "absolute",
                      top: "-9px",
                      left: "35px",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ backgroundColor: "white" }}>
                      Vaccination Book
                    </span>
                  </h6>

                  <div
                    className="d-flex justify-content-between align-items-center w-100 border rounded p-2"
                    style={{ border: "3px solid rgb(229 225 225)" }}
                  >
                    <div className="p-2" style={{ flex: 1 }}>
                      {firstItem.VaccinationBook_Front?.trim() ? (
                        <img
                          alt="Vaccination Book Front"
                          src={VaccinationBook_Front}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook1"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook1"
                        name="VaccinationBook_Front"
                        type="file"
                        className="form-control mt-2"
                      />
                    </div>

                    <div className="p-2 text-center" style={{ flex: 1 }}>
                      {firstItem.VaccinationBook_Back?.trim() ? (
                        <img
                          alt="Vaccination Book Back"
                          src={vaccinationBookBack}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook2"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook2"
                        name="VaccinationBook_Back"
                        type="file"
                        className="form-control mt-2"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="col-md-6 col-12 px-2 mb-4 d-flex flex-column align-items-center"
                  style={{ position: "relative" }}
                >
                  <h6
                    className="text-start"
                    style={{
                      color: "#6a6a6a",
                      width: "94%",
                      position: "absolute",
                      top: "-9px",
                      left: "35px",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ backgroundColor: "white" }}>Pet Photos</span>
                  </h6>

                  <div
                    className="d-flex justify-content-between align-items-center w-100 border rounded p-2"
                    style={{ border: "3px solid rgb(229 225 225)" }}
                  >
                    <div className="p-2" style={{ flex: 1 }}>
                      {firstItem.Pet_Photo_Sitting?.trim() ? (
                        <img
                          alt="Pet Sitting"
                          src={petPhotosSitting}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook3"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook3"
                        name="Pet_Photo_Sitting"
                        type="file"
                        className="form-control mt-2"
                      />
                    </div>

                    <div className="p-2 text-center" style={{ flex: 1 }}>
                      {firstItem.Pet_Photo_Standing?.trim() ? (
                        <img
                          alt="Pet Standing"
                          src={petPhotosStanding}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook4"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook4"
                        name="Pet_Photo_Standing"
                        type="file"
                        className="form-control mt-2"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="from-row row align-item-start g-3">
                <div className="col-md-12 col-12 text-start">
                  <hr className="m-0"></hr>
                </div>
              </div>
              {/* <div className="form-row row align-items-start g-3 py-3">
                <div className="col-12 text-start d-flex justify-content-end">
                  <button
                    onClick={handleSaveAndNext}
                    type="button"
                    className="btn btn-primary"
                    style={{
                      fontWeight: "bold",
                      padding: "10px 20px",
                      border: "1px solid gray",
                      width: "11rem",
                      backgroundColor: "white",
                      color: "#6A6A6A",
                      borderRadius: "9px",
                    }}
                  >
                    SAVE
                    <span
                      style={{
                        fontSize: "20px",
                        position: "relative",
                        left: "7px",
                      }}
                    >
                      &rarr;
                    </span>
                  </button>
                </div>
              </div> */}
            </div>
          </div>
          <style jsx>{`
          .hide-mobile-view {
    display: block;
}
    .hide-mobile-view{
    display: none;
    }

    .order-by-mukul_change{
      box-shadow:rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
                back-groundColor: white;
    }
                .for-mobile-none{
                display: none;
                }

/* Hide on screens smaller than 768px (mobile) */
@media (max-width: 767px) {
.for-mobile-none {
  display: Block;
}
.for-mobile-none{
     border-radius: 5px 5px 0 0;
     margin-bottom: 3px;
                }
.for-desktop-m{
display: none;
}
.booking_form-mobile-view{
padding: 18px !important;
}
.for-mobile-version2{
margin-top: 31px !important;
margin-bottom: 1px !important;
}
.for-mobile-version1{
margin-top: 31px !important;
}
.for-mobile-version{
margin-top: -9px !important;
}
.order-by-mukul_change{
      box-shadow:
                  none;
                back-groundColor: none;
    }
.arrow-download_page{
border: 1px solid #5B489D !important;
width: 49.37px !important;
}
    .hide-mobile-view {
        display: none;
    }

    .hide-mobile-view{
    display: block;
    }
} {
    display: block;
}

/* Hide on screens smaller than 768px (mobile) */
@media (max-width: 767px) {
    .hide-desktop-view {
        display: none;
    }
    
}


/* mobile view css*/

.lead-info-box {
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
  padding: 24px 16px 24px 16px;
  border-radius: 0 0 5px 5px;
}

.lead-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 18px;
}

.lead-label {
  width: 160px;
  color: #6a6a6a;
}

.lead-colon {
  width: 20px;
  color: #6a6a6a;
}

.lead-value {
  font-weight: 500;
  color: #333;
}
           `}</style>
        </>
      ) : (
        //--------------------------------------------------------------------------View Mode---------------------------------------------------

        <div>
          <div className="pt-4 pr-[23px] pb-4 pl-[20px] lg:py-4 lg:px-[15.5rem]">
            <div
              className="pt-3 pr-[23px] pb-3 pl-[20px] lg:py-[1rem] lg:px-[2rem]"
              style={{
                borderRadius: "7px",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                backgroundColor: "white",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="hidden sm:inline-block text-[12px] lg:text-[20px] font-semibold border-b-2 border-blue-500 pb-1 pl-2 m-0">
                  BOOKING FORM
                </h2>

                {/* <button onClick={() => setIsEditMode(!isEditMode)}>
  Toggle Edit/View
</button> */}
                <button
                  type="button"
                  // onClick={handleBack}
                  className="font-bold border border-gray-300 text-[#6A6A6A] rounded-[9px] bg-white transition-all
               px-3 py-2 text-[12px] sm:text-[14px] lg:text-[16px] w-[8rem] sm:w-[9.5rem] lg:w-[11rem]"
                >
                  <span className="text-[16px] sm:text-[18px] relative left-[-8px]">
                    &larr;
                  </span>
                  BACK
                </button>
              </div>
            </div>
          </div>

          <div
            style={{ marginBottom: "30px" }}
            className="lg:py-4 lg:px-[15.5rem]"
          >
            <div
              className="p-3 lg:py-[1rem] lg:px-[2rem]"
              style={{
                borderRadius: "7px",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                backgroundColor: "white",
              }}
            >
              <h1
                className="mt-3 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
              >
                Booking Person
              </h1>

              <div className="form-row row align-items-start g-3 mt-3">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Lead ID
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Relocation_ID || "Enter"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Full Name
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.First_Name || "Enter"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start position-relative">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Contact Number
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px 8px 34px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                      position: "relative",
                    }}
                    className="form-control m-0"
                  >
                    <CallIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                      }}
                    />
                    {orderSummary.Mobile_No || "Enter Contact"}
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start position-relative">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Alternate Number
                  </label>

                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // padding to avoid overlap with icon
                        height: "38px", // consistent height for alignment
                        borderRadius: "4px",
                      }}
                      name="alternate_number"
                      type="number"
                      className="form-control m-0"
                      placeholder="Enter"
                      value={firstItem.alternate_number}
                      onChange={handleChange1}
                    />
                    <SmartphoneIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        pointerEvents: "none", // prevent accidental clicks
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row row align-item-start g-3 pt-4">
                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Email ID
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // Add space for the icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="email"
                      name="Email"
                      className="form-control m-0"
                      placeholder="Enter"
                      value={firstItem.Email}
                      // onChange={handleChange1}
                      disabled
                    />
                    <MailOutlineIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // Add space for the icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      name="origin_address"
                      className="form-control m-0"
                      placeholder="Enter"
                      value={firstItem.origin_address}
                      onChange={handleChange1}
                    />
                    <LocationOnIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="form-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pin Code
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // Add space for the icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      name="Origin_Pin"
                      className="form-control m-0"
                      placeholder="Enter"
                      value={firstItem.Origin_Pin}
                      onChange={handleChange1}
                    />
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    State
                  </label>
                  <select
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                    }}
                    className="form-select m-0"
                    aria-label=""
                    name="Origin_State"
                    value={firstItem.origin_state}
                    onChange={handleSelectChangeOriginState}
                  >
                    <option value="0">Select an option</option>
                    {originStateResponse.map((item) => (
                      <option value={item.state_id}>{item.stateName}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    City
                  </label>
                  <select
                    className="form-select m-0"
                    name="Origin_City"
                    value={firstItem.origin_city}
                    onChange={handleChange2}
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    aria-label="Select City"
                  >
                    <option value="">Select an option</option>
                    {originCityResponse.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {/*---------------------------------------------------------------Relocation Details Sender's Details (Same As Customer Details)------------------------------------------ */}
              <h1
                className="mt-5 mb-4 *:ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
              >
                Relocation Details
              </h1>
              <span>
                Sender's Details{" "}
                <span style={{ color: "#00A3FF" }}>
                  (Same As Customer Details)
                </span>
              </span>
              <hr className="m-0"></hr>

              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Country
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_country1 || "Enter"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Full Name
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="First_Name"
                    value={firstItem.First_Name}
                    // onChange={handleChange1}
                    disabled
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Contact Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // enough space for icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="Mobile_No"
                      value={firstItem.Mobile_No}
                      onChange={handleChange1}
                    />
                    <CallIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Alternate Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // for icon spacing
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="sender_alternate_no"
                      value={firstItem.alternate_no}
                      onChange={handleChange1}
                    />
                    <SmartphoneIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Email Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // Space for icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="email"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="Email"
                      value={firstItem.Email}
                      // onChange={handleChange1}
                      disabled
                    />
                    <MailOutlineIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Address
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="origin_address"
                    value={firstItem.origin_address}
                    onChange={handleChange1}
                  />
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pin Code
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="Origin_Pin"
                    value={firstItem.Origin_Pin}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    State
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_state1 || "Enter"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    City
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.origin_city1 || "Enter"}
                  </div>
                </div>
              </div>
              {/* -------------------------------------------Reciever's Details---------------------------------------------------------------------*/}
              <div className="from-row row align-item-start g-3 my-3">
                <div className="col-md-12 col-12 text-start">
                  <span>
                    Reciever's{" "}
                    <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                      Details
                    </span>
                  </span>
                  <hr className="mt-1"></hr>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-3">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Country
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_country1 || "Enter"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Full Name
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="destination_contact_person"
                    value={firstItem.destination_contact_person}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Contact Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // enough space for icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="receiver_contact_no"
                      value={firstItem.receiver_contact_no}
                      onChange={handleChange1}
                    />
                    <CallIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Alternate Number
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // for icon spacing
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="text"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="receiver_alternate_no"
                      value={firstItem.receiver_alternate_no}
                      onChange={handleChange1}
                    />
                    <SmartphoneIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Email Address
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      style={{
                        border: "1px solid #5B489D",
                        width: "100%",
                        fontSize: "14px",
                        paddingLeft: "34px", // Space for icon
                        height: "38px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                      }}
                      type="email"
                      className="form-control m-0"
                      placeholder="Enter"
                      name="receiver_alternate_email"
                      value={firstItem.receiver_alternate_email}
                      onChange={handleChange1}
                    />
                    <MailOutlineIcon
                      style={{
                        color: "#6a6a6a",
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        transform: "translateY(-50%)",
                        fontSize: "16px",
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Address
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="destination_address"
                    value={firstItem.destination_address}
                    onChange={handleChange1}
                  />
                </div>
              </div>

              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pin Code
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="number"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="Destination_Pin"
                    value={firstItem.Destination_Pin}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    State
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_state1 || "Enter"}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    City
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.destination_city1 || "Enter"}
                  </div>
                </div>
              </div>
              {/* ----------------------------------------------------------Pet Details--------------------------------------------------------------------------------------- */}
              <h1
                className="mt-5 mb-4 ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
              >
                Pet Details
              </h1>
              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Owner's name on Vaccination Book
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    // value={ || 'Enter'}
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Type
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.PetType}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Name (on vaccination book)
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.pet_Name}
                  </div>
                </div>
              </div>
              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Breed
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.petbreedtype}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Gender
                  </label>
                  <select
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    className="form-select m-0"
                    aria-label="Default select example"
                    name="pet_gender"
                    value={firstItem.pet_gender}
                    onChange={handleChange1}
                  >
                    <option value="">Select an option</option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                  </select>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Age
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Pet_Age}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pet Color
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="pet_color"
                    value={firstItem.pet_color}
                    onChange={handleChange1}
                  />
                </div>
              </div>
              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-6 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    {" "}
                    Pet Behaviour
                  </label>
                  <input
                    style={{
                      border: "2px solid #5B489D",
                      paddingLeft: "10px",
                      fontWeight: "bold",
                      width: "100%",
                    }}
                    type="text"
                    className="form-control m-0"
                    placeholder="Enter"
                    name="pet_behaviour"
                    value={firstItem.pet_behaviour}
                    onChange={handleChange1}
                  />
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pet Length (A)
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Pet_Length}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pet Height From Ground To Elbow Joint (B)
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Pet_Height}
                  </div>
                </div>
              </div>
              <div className="from-row row align-item-start g-3 pt-4">
                <div className="col-md-3 col-6 text-start">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pet Width (C)
                  </label>
                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Pet_Width}
                  </div>
                </div>
                <div className="col-md-3 col-6 text-start position-relative">
                  <label style={{ color: "#6a6a6a" }} className="form-label">
                    Pet Height (D)
                  </label>

                  <div
                    style={{
                      border: "1px solid #5B489D",
                      width: "100%",
                      fontSize: "14px",
                      padding: "8px 10px",
                      fontWeight: "bold",
                      borderRadius: "4px",
                      backgroundColor: "#f9f9f9",
                    }}
                    className="form-control m-0"
                  >
                    {orderSummary.Pet_Height}
                  </div>

                  {/* Info icon with tooltip */}
                  <a
                    href="https://www.carrymypet.com/pet-measurement"
                    target="blank"
                    className="position-absolute"
                    style={{
                      top: "73%",
                      right: "-6px",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#6a6a6a",
                      fontSize: "27px",
                      textDecoration: "none",
                    }}
                  >
                    &#x1F6C8;
                  </a>
                </div>
              </div>

              {/* <h1
                className="mt-5 mb-4
               ml-[1px] bg-[#5B489D] text-white text-[20px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
              >
                Pet Related Pictures
              </h1> */}

              {/* <div className="form-row row text-center px-0 py-3 d-flex justify-content-between pet-detail-main-form ">
                <div
                  className="col-md-6 col-12 px-2 mb-4 d-flex flex-column align-items-center"
                  style={{ position: "relative" }}
                >
                  <h6
                    className="text-start"
                    style={{
                      color: "#6a6a6a",
                      width: "94%",
                      position: "absolute",
                      top: "-9px",
                      left: "35px",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ backgroundColor: "white" }}>
                      Vaccination Book
                    </span>
                  </h6>

                  <div
                    className="d-flex justify-content-between align-items-center w-100 border rounded p-2"
                    style={{ border: "3px solid rgb(229 225 225)" }}
                  >
                    
                    <div className="p-2" style={{ flex: 1 }}>
                      {firstItem.VaccinationBook_Front?.trim() ? (
                        <img
                          alt="Vaccination Book Front"
                          src={VaccinationBook_Front}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook1"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook1"
                        name="VaccinationBook_Front"
                        type="file"
                        className="form-control mt-2"
                        onChange={handleFileChange}
                      />
                    </div>

                   
                    <div className="p-2 text-center" style={{ flex: 1 }}>
                      {firstItem.VaccinationBook_Back?.trim() ? (
                        <img
                          alt="Vaccination Book Back"
                          src={vaccinationBookBack}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook2"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook2"
                        name="VaccinationBook_Back"
                        type="file"
                        className="form-control mt-2"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div>

                
                <div
                  className="col-md-6 col-12 px-2 mb-4 d-flex flex-column align-items-center"
                  style={{ position: "relative" }}
                >
                  <h6
                    className="text-start"
                    style={{
                      color: "#6a6a6a",
                      width: "94%",
                      position: "absolute",
                      top: "-9px",
                      left: "35px",
                      fontWeight: "600",
                    }}
                  >
                    <span style={{ backgroundColor: "white" }}>Pet Photos</span>
                  </h6>

                  <div
                    className="d-flex justify-content-between align-items-center w-100 border rounded p-2"
                    style={{ border: "3px solid rgb(229 225 225)" }}
                  >
                    <div className="p-2" style={{ flex: 1 }}>
                      {firstItem.Pet_Photo_Sitting?.trim() ? (
                        <img
                          alt="Pet Sitting"
                          src={petPhotosSitting}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook3"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook3"
                        name="Pet_Photo_Sitting"
                        type="file"
                        className="form-control mt-2"
                        onChange={handleFileChange}
                      />
                    </div>

                   
                    <div className="p-2 text-center" style={{ flex: 1 }}>
                      {firstItem.Pet_Photo_Standing?.trim() ? (
                        <img
                          alt="Pet Standing"
                          src={petPhotosStanding}
                          className="img-fluid"
                          style={{ maxHeight: "236px" }}
                        />
                      ) : (
                        <label
                          htmlFor="vaccinationBook4"
                          style={{ color: "#6a6a6a", cursor: "pointer" }}
                        >
                          <PhotoIcon fontSize="large" />
                        </label>
                      )}
                      <input
                        id="vaccinationBook4"
                        name="Pet_Photo_Standing"
                        type="file"
                        className="form-control mt-2"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="from-row row align-item-start g-3">
                <div className="col-md-12 col-12 text-start">
                  <hr className="m-0"></hr>
                </div>
              </div>
              <div className="form-row row align-items-start g-3 py-3">
                <div className="col-12 text-start d-flex justify-content-end">
                  <button
                    onClick={handleSaveAndNext}
                    type="button"
                    className="btn btn-primary"
                    style={{
                      fontWeight: "bold",
                      padding: "10px 20px",
                      border: "1px solid gray",
                      width: "11rem",
                      backgroundColor: "white",
                      color: "#6A6A6A",
                      borderRadius: "9px",
                    }}
                  >
                    SAVE & NEXT{" "}
                    <span
                      style={{
                        fontSize: "20px",
                        position: "relative",
                        left: "7px",
                      }}
                    >
                      &rarr;
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* -------------------------------------------PDF Div ------------------------------------------------------------ */}

      <div
        id="pdf-content"
        // style={{
        //   marginBottom: "30px",
        //   width: "100%",
        //   maxWidth: "920.701px",
        //   margin: "auto",
        //   padding: "3px 2px 5px 2px",
        //   fontFamily: "Arial, sans-serif",
        //   color: "#333",
        // }}

        style={{
          position: "absolute",
          left: "-9999px", // Move it off-screen
          top: "0",
          width: "100%",
          maxWidth: "920.701px",
          padding: "3px 2px 5px 2px",
          fontFamily: "Arial, sans-serif",
          color: "#333",
        }}
        className="lg:py-4 lg:px-[15.5rem] "
      >
        <div
          className="p-0 lg:py-[1rem] lg:px-[2rem]"
          style={{
            borderRadius: "7px",
            boxShadow:
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
            backgroundColor: "white",
          }}
        >
          <div className="row align-items-start g-3 mt-0">
            <div className="col-12 text-start mt-0 p-0">
              <img
                src={banner}
                alt="Pet Image"
                className="img-fluid"
                style={{
                  width: "58.1rem",
                  marginLeft: "0px",
                  marginRight: "0px",
                }}
              />
            </div>
          </div>

          <div
            className="px-5 py-3 lg:py-[1rem] lg:px-[2rem]"
            style={{
              borderRadius: "7px",
              boxShadow:
                "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
              backgroundColor: "white",
            }}
          >
            <h2
              className="mt-0 ml-[1px] text-Black text-[27px] px-3 pt-[9px] pb-[2px] 
             font-bold rounded-tl-[10px] rounded-tr-[10px] rounded-br-none rounded-bl-none"
            >
              BOOKING <span style={{ color: "#6f42c1" }}>FORM</span>
            </h2>
            <h1
              className="mt-3 mb-0 ml-[1px] bg-[#5B489D] text-white text-[13px] px-3 pt-[9px] pb-[9px] 
              font-bold rounded-tl-[5px] rounded-tr-[5px] rounded-bl-[5px] rounded-br-[5px] rounded-br-none rounded-bl-none"
            >
              <span className="text-[13px] mt-[4px]">Pet Details</span>
            </h1>

            <div className="form-row row align-items-start g-3 mt-0">
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Lead ID
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.Relocation_ID || "NA"}
                </div>
              </div>

              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Full Name
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.First_Name || "NA"}
                </div>
              </div>

              <div className="col-md-3 col-6 text-start position-relative">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Contact Number
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.Mobile_No || "NA"}
                </div>
              </div>

              <div className="col-md-3 col-6 text-start position-relative">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Alternate Number
                </label>

                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // left padding for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.alternate_number || "NA"}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Email ID
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // left padding for icon
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                      position: "relative",
                    }}
                  >
                    {orderSummary.Email || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Address
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",
                      //  backgroundColor: "#f9f9f9",
                      position: "relative",
                    }}
                  >
                    {orderSummary.origin_address || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pin Code
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Origin_Pin || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  State
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px", // space for icon
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.origin_state1 || "NA"}
                </div>
              </div>
            </div>

            <div className="form-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  City
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px", // space for icon
                    fontWeight: "bold",
                    borderRadius: "4px",
                    //  backgroundColor: "#f9f9f9",
                    position: "relative",
                  }}
                >
                  {orderSummary.origin_city1 || "NA"}
                </div>
              </div>
            </div>

            <h1
              className="mt-0 mb-2 ml-[1px] bg-[#5B489D] text-white text-[13px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[5px] rounded-tr-[5px] rounded-bl-[5px] rounded-br-[5px] rounded-br-none rounded-bl-none"
            >
              Relocation Details
            </h1>
            <span className="text-[12px] mt-0" style={{ marginBottom: "4px" }}>
              Sender's Details{" "}
              {/* <span style={{ color: "#00A3FF" }}>
                  (Same As Customer Details)
                </span> */}
            </span>
            <hr className="m-1"></hr>

            <div className="from-row row align-item-start g-3 pt-2">
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Country
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    //  backgroundColor: "#f9f9f9",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.origin_country1 || "NA"}
                </div>
              </div>
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Full Name
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.First_Name || "NA"}
                </div>
              </div>
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Contact Number
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // for icon spacing
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Mobile_No || "NA"}
                  </div>
                </div>
              </div>

              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Alternate Number
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.alternate_number || "NA"}
                  </div>
                </div>
              </div>
            </div>

            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Email Address
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.Email || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Address
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px", // space for icon
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.origin_address || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pin Code
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px", // space for icon
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.Origin_Pin || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  State
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    //  backgroundColor: "#f9f9f9",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.origin_state1 || "NA"}
                </div>
              </div>
            </div>

            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  City
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.origin_city1 || "NA"}
                </div>
              </div>
            </div>
            {/* Reciever's Details*/}
            <div className="from-row row align-item-start g-3 mt-0 mb-1">
              <div className="col-md-12 col-12 text-start text-[12px] mt-0">
                <span
                  className="text-[12px] mt-0"
                  style={{ marginBottom: "1px" }}
                >
                  Reciever's{" "}
                  <span style={{ color: "#5B489D", fontWeight: "bold" }}>
                    Details
                  </span>
                </span>
                <hr className="mt-1"></hr>
              </div>
            </div>

            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Country
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    //  backgroundColor: "#f9f9f9",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.destination_country1 || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Full Name
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.destination_contact_person || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Contact Number
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // for icon spacing
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.receiver_contact_no || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Alternate Number
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.receiver_alternate_no || "NA"}
                  </div>
                </div>
              </div>
            </div>

            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Email Address
                </label>
                <div style={{ position: "relative" }}>
                  <div
                    className="form-control m-0"
                    style={{
                      border: "0px solid #5B489D",
                      width: "100%",
                      fontSize: "12px",
                      padding: "1px 10px 8px 10px", // space for icon
                      fontWeight: "bold",
                      borderRadius: "4px",

                      position: "relative",
                    }}
                  >
                    {orderSummary.receiver_alternate_email || "NA"}
                  </div>
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Address
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px 8px 10px", // space for icon
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.destination_address || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pin Code
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.Destination_Pin || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  State
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.destination_state1 || "NA"}
                </div>
              </div>
            </div>

            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  City
                </label>
                <div
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                  }}
                  className="form-control m-0"
                >
                  {orderSummary.destination_city1 || "NA"}
                </div>
              </div>
            </div>

            <h1
              className="mt-0 mb-2 ml-[1px] bg-[#5B489D] text-white text-[13px] px-3 pt-[9px] pb-[9px] 
             font-bold rounded-tl-[5px] rounded-tr-[5px] rounded-bl-[5px] rounded-br-[5px] rounded-br-none rounded-bl-none"
            >
              Pet Details
            </h1>
            <div className="from-row row align-item-start g-3 pt-2">
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Owner's name on Vaccination Book
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {}
                </div>
              </div>
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Type
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.PetType || "NA"}
                </div>
              </div>
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Name (on vaccination book)
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    //  backgroundColor: "#f9f9f9",
                    position: "relative",
                  }}
                >
                  {orderSummary.pet_Name || "NA"}
                </div>
              </div>
              <div className="col-md-3 col-6 text-start">
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Breed
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.petbreedtype || "NA"}
                </div>
              </div>
            </div>
            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Gender
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.pet_gender === "1" ? "Male" : "Female"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Age
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.Pet_Age || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pet Color
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.pet_color || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  {" "}
                  Pet Behaviour
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.pet_behaviour || "NA"}
                </div>
              </div>
            </div>
            <div className="from-row row align-item-start g-3 pt-2">
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pet Length (A)
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.Pet_Length || "NA "}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pet Height From Ground To Elbow Joint (B)
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.container_length || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pet Width (C)
                </label>
                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",

                    position: "relative",
                  }}
                >
                  {orderSummary.Pet_Width || "NA"}
                </div>
              </div>
              <div
                className="col-md-3 col-6 text-start position-relative"
                style={{ marginTop: "2px" }}
              >
                <label
                  style={{ color: "#6a6a6a", marginBottom: "4px" }}
                  className="form-label ml-0 text-[11px]"
                >
                  Pet Height (D)
                </label>

                <div
                  className="form-control m-0"
                  style={{
                    border: "0px solid #5B489D",
                    width: "100%",
                    fontSize: "12px",
                    padding: "1px 10px",
                    fontWeight: "bold",
                    borderRadius: "4px",
                    position: "relative",
                  }}
                >
                  {orderSummary.Pet_Height || "NA"}
                </div>
              </div>
            </div>

            <div
              className="form-row row align-items-start g-3 mt-0 mb-1"
              style={{ paddingTop: "35px" }}
            >
              <div className="col-md-12 col-12 text-[12px] mt-0">
                <hr className="mt-1 border-gray-400" />
                <span className="block text-end text-[12px]">01</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* -------------------------------------------End PDF Div -------------------------------------------------------- */}
    </div>
  );
}

export default BookingForm;
